module.exports = __webpack_public_path__ + "img/good-health-and-well-being.16614c71.png";